/* eslint-disable no-void */

import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };

type HookTuple = [
  response: vp.DefaultPaymentMethodResponse,
  fetchData: (params: vp.DefaultPaymentMethodRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchDefaultPaymentMethod: ApiHook = ({ api }: HookProps) => {
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.DefaultPaymentMethodRequest>({});
  const [response, setResponse] = useState<vp.DefaultPaymentMethodResponse>({
    Success: false,
    ErrorMessage: '',
    DefaultPaymentMethod: 'vopay',
  });

  const [shouldSendRequest, setSendRequest] = useState(false);

  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async () => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.fetchDefaultPaymentMethod(params);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest();

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (_params: vp.DefaultPaymentMethodRequest) => {
      setParams(_params);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        DefaultPaymentMethod: 'vopay',
      });
      setSendRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchDefaultPaymentMethod);
